import { BaseController } from '~client/controller/base-controller';
import { ConfigurationResponse } from '~client/model/configuration-response';

/* User APIs for various configurations */
export class ConfigurationController extends BaseController {
  /* Returns initial configuration */
  public getConfiguration(): Promise<ConfigurationResponse> {
    return this.get('/configuration/public');
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/client/src/controller/configuration-controller.ts